export default {
    type: 'formType',
};
